// src/components/checkout/PaymentOptions.jsx
import React from "react";
import useCheckoutStore from "../../store/useCheckoutStore";

const PaymentOptions = ({ payment }) => {
  const { updateCheckoutData } = useCheckoutStore();

  return (
    <div className="card payment-options">
      <h2>Metoda płatności</h2>
      <div className="payment-radio-group">
        {[
          { value: "cash", label: "Gotówka przy odbiorze" },
          { value: "card", label: "Karta przy odbiorze" },
        ].map((option) => (
          <label key={option.value} className="payment-option">
            <input
              className="payment-radio"
              type="radio"
              name="payment"
              value={option.value}
              checked={payment === option.value}
              onChange={(e) => updateCheckoutData({ payment: e.target.value })}
            />
            <span>{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default PaymentOptions;